import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Button, MenuItem, Box } from "@mui/material";
import { blue } from '@material-ui/core/colors/';
import ComputerIcon from '@mui/icons-material/Computer';
import { useFormik, } from 'formik';
import * as Yup from 'yup';
import { addHardware, getAllCompanyValue, getAllHardwareModels, getUser } from '../../services/service';
import { FormDialog } from '../FormDialog';
import { APISelectField } from '../APISelectField';
import { APITextField } from '../APITextField';

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[700],
  '&:hover': {
    backgroundColor: blue[900],
  },
}));

const validationSchema = Yup.object({
  manufacturer: Yup
    .string('Enter the hardware company name')
    .required('Field is required'),
  model: Yup
    .string('Enter hardware model')
    .required('model is required'),
  arch: Yup.string()
    .oneOf(['x86-64', 'armhf', 'armv7'])
    .required('Necessário escolher a quantidade!'),
})

export default function BtnAddHardwareModel({ onHardwareModelCreated, sx }) {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      company: "",
      hardware_model: "",
      hardware_key: "",
      name: "",
      description: "",
    },
    validationSchema: validationSchema,
  })

  const onSubmit = () => {
    setLoading(true)
    addHardware(
      formik.values.company,
      formik.values.hardware_model,
      formik.values.hardware_key,
      formik.values.name,
      formik.values.description,
    ).then((response) => {
      setOpen(false);
      onHardwareModelCreated(response.data);
      formik.resetForm();
    })
      .catch(err => {
        setErrors(err.response.data);
      })
      .finally((resp) => {
        setLoading(false)
      })
  }

  const handleClickOpen = () => {
    setOpen(true);

  };

  const handleClose = () => {
    setOpen(false);
  };

  const [allCompany, setAllcompany] = useState([])
  const [allHardwareModels, setAllHardwareModels] = useState([])

  useEffect(() => {
    getAllCompanyValue().then((resp) => {
      setAllcompany(resp.data.results)
    }).catch((err) => {
      if (err.response.status === 403) {
        getUser().then((resp) => {
          setAllcompany([resp.data.company])
        })
      }
    })
  }, [getAllCompanyValue])

  useEffect(() => {
    getAllHardwareModels().then((resp) => setAllHardwareModels(resp.data.results))
  }, [getAllHardwareModels])

  return (
    <Box sx={sx}>
      <ColorButton
        startIcon={<ComputerIcon></ComputerIcon>}
        onClick={handleClickOpen}
        size="larger"
        variant="contained"
        sx={{ padding: 2, width: "100%" }}
      >
        Adicionar hardware
      </ColorButton>
      <FormDialog
        title={"Adicionar Hardware"}
        open={open}
        onDismiss={handleClose}
        formWidth={500}
        loading={loading}
        onSubmit={onSubmit}
      >
        <APISelectField
          name="company"
          label={"Empresa"}
          value={formik.values.company}
          onChange={formik.handleChange}
          errors={errors?.company}
          variant={"standard"}
        >
          {allCompany.map((companyValue, idx) => (
            <MenuItem key={idx} value={companyValue.id}>
              {companyValue.name}
            </MenuItem>
          ))}

        </APISelectField>
        <APISelectField
          name="hardware_model"
          value={formik.values.hardware_model}
          errors={errors?.hardware_model}
          variant={"standard"}
          label={"Modelo do Hardware"}
          onChange={formik.handleChange}
        >
          {allHardwareModels.map((hwModel, idx) => (
            <MenuItem key={idx} value={hwModel.id}>
              {hwModel.model}
            </MenuItem>
          ))}

        </APISelectField>
        <APITextField
          id="hardware_key"
          name="hardware_key"
          label="Chave do hardware"
          disabled={loading}
          value={formik.values.hardware_key}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.hardware_key}
        />
        <APITextField
          id="hardware-name"
          name="name"
          label="Nome do hardware "
          disabled={loading}
          value={formik.values.name}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.name}
        />
        <APITextField
          id="description"
          label="Descrição do hardware "
          disabled={loading}
          value={formik.values.description}
          onChange={formik.handleChange}
          variant="standard"
          errors={errors?.description}
        />
      </FormDialog>
    </Box >
  );
}